export const FIXED_PATHS = { census: "/census", birthdays: "/birthdays" };

export const tplPath = (t) => FIXED_PATHS[t.kind] || `/forms/${t.template_id}`;
